<div class="checkCustom checkBoxFormulario" [ngClass]="{'soloLectura' : disabled, 'izquierda' : alineacion == AlineacionEnum.Izquierda, 'derecha' : alineacion == AlineacionEnum.Derecha, 'sinMargen' : sinMargen}">

  <div class="checkBoxInput">
    <div class="formaCheckBox" tabindex="0" (keypress)="TeclaPresionada($event)">
      <input type="checkbox" id="checkboxCutom{{id}}" [(ngModel)]="valor"/>
      <label for="checkboxCutom{{id}}"></label>
    </div>
  </div>

  <div class="checkBoxLabel">
    <label for="checkboxCutom{{id}}">{{titulo}}</label>
  </div>

</div>
